import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\">\n<g id=\"icon-down_Group 427323849\">\n<path id=\"icon-down_Vector 24\" d=\"M3 4.60001L6.18198 7.78199L9.36396 4.60001\" stroke=\"#DBDBDB\" stroke-width=\"1.5\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol